import axios from "axios";
import { toastr } from "react-redux-toastr";
import { logout } from "./auth";

// The Bundles page: the page bundles on sale (/api/bundles/admin/plans), what was sold
// and printed from them (/api/bundles/admin/summary), and the bundles customers have
// (/api/bundles/admin/bundles), the backend's routes/api/bundles.js. Kept on the page,
// not in the store: each call returns what the backend sent, or null when it failed
// and the error was shown.

// Shows the backend's { errors: [{ msg }] } and logs out on an expired token
const handleError = (err, dispatch) => {
	// No response: the network or the server is down
	if (!err.response) {
		toastr.error("Сервертэй холбогдож чадсангүй");
		return;
	}
	if (err.response.status === 401 && err.response.data.msg === "Token is not valid") {
		window.localStorage.clear("x-auth-token");
		toastr.error("Session expired");
		dispatch(logout());
	}
	const errors = err.response.data.errors;
	if (errors) {
		errors.forEach((error) => toastr.error(error.msg));
	}
};

const config = {
	headers: {
		"Content-Type": "application/json",
	},
};

// A backend without these routes answers with the admin's index.html and a 200
const isList = (data) => Array.isArray(data);
const isPlan = (data) => Boolean(data) && typeof data.id === "string" && typeof data.price === "number";
const isSummary = (data) => Boolean(data) && Array.isArray(data.sold) && typeof data.soldAmount === "number";
const isAdjusted = (data) => Boolean(data) && typeof data.id === "string";

const call = async (dispatch, request, isRight, done) => {
	try {
		const res = await request();
		if (!isRight(res.data)) {
			toastr.error("Серверийн хариу буруу байна");
			return null;
		}
		if (done) toastr.success(done);
		return res.data;
	} catch (err) {
		handleError(err, dispatch);
		return null;
	}
};

//  Every plan, on sale or not
export const getBundlePlans = () => (dispatch) =>
	call(dispatch, () => axios.get("/api/bundles/admin/plans"), isList);

//  Adds (no id) or saves a plan: { name, pages, price, validityDays, shareable, active, sort }
export const saveBundlePlan = (id, body) => (dispatch) =>
	call(
		dispatch,
		() =>
			id
				? axios.put(`/api/bundles/admin/plans/${id}`, body, config)
				: axios.post("/api/bundles/admin/plans", body, config),
		isPlan,
		"Хадгалагдлаа"
	);

//  Sold and printed from startDate to endDate ("YYYY-MM-DD"), and what customers hold
export const getBundleSummary = (startDate, endDate) => (dispatch) =>
	call(
		dispatch,
		() => axios.get("/api/bundles/admin/summary", { params: { startDate, endDate } }),
		isSummary
	);

//  The bundles of the customer with that email, or the latest sold
export const getBundles = (email) => (dispatch) =>
	call(dispatch, () => axios.get("/api/bundles/admin/bundles", { params: email ? { email } : {} }), isList);

//  What a mono page costs printed one by one (the Settings page's price), to show
//  what a plan saves, or null when it is not known. Nothing is shown when it fails.
export const getMonoPrice = () => async () => {
	try {
		const res = await axios.get("/api/product");
		const row = Array.isArray(res.data)
			? res.data.find((item) => item.product === "printing" && item.type === "mono")
			: null;
		return row && row.price > 0 ? row.price : null;
	} catch (err) {
		return null;
	}
};

//  Gives a bundle pages and days; its owner is told
export const adjustBundle = (id, pages, days) => (dispatch) =>
	call(
		dispatch,
		() => axios.post(`/api/bundles/admin/bundles/${id}/adjust`, { pages, days }, config),
		isAdjusted,
		"Багц шинэчлэгдлээ"
	);

// Team photos for the stories (/api/team-photos/admin, the backend's routes/api/teamPhotos.js)
const isStoryList = (data) => Boolean(data) && Array.isArray(data.photos) && Boolean(data.counts);
const isStoryPhoto = (data) => Boolean(data) && typeof data.id === "string" && typeof data.status === "string";

//  Story photos by where they stand: review, public, waiting, declined or rejected
export const getTeamPhotos = (status) => (dispatch) =>
	call(dispatch, () => axios.get("/api/team-photos/admin/photos", { params: { status } }), isStoryList);

//  Lets a story photo in, or keeps it out; its team is told
export const reviewTeamPhoto = (id, approve) => (dispatch) =>
	call(
		dispatch,
		() => axios.post(`/api/team-photos/admin/photos/${id}/review`, { approve }, config),
		isStoryPhoto,
		approve ? "Нийтэллээ" : "Нууллаа"
	);
